import { QueryTable } from "@/components/query-table/QueryTable";
import { memo } from "react";

const ProjectSchedulesMenubarComponent = () => {
  return (
    <QueryTable.Menubar className="grow my-2">
      <QueryTable.Menubar.Tools />
      <QueryTable.Menubar.Columns />
      <QueryTable.Menubar.Settings />
    </QueryTable.Menubar>
  );
};

export const ProjectSchedulesMenubar = memo(ProjectSchedulesMenubarComponent);
